import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { FC } from "react";

import { Container } from "@/components/General/Grid/container.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { OrderItemModel } from "@/redux/modules/api/data/orderDetail/@types/orderItem.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { DeliveryPromiseComponentProps } from "../OrderItem/orderItem.component";
import { ProductCollectionBlockComponent } from "./productCollectionBlock.component";

type ProductCollectionProps = {
    collectProducts: Array<OrderItemModel>;
    deliveryProducts: Array<OrderItemModel>;
    additionalServiceTooltip?: TooltipType;
    productTitleLink: boolean;
    DeliveryPromiseComponent: FC<DeliveryPromiseComponentProps>;
};

const ProductCollectionBlock = ({
    collectProducts,
    deliveryProducts,
    additionalServiceTooltip,
    productTitleLink,
    DeliveryPromiseComponent
}: ProductCollectionProps) => {
    const { t } = useGranite();

    const isClickAndCollect = collectProducts.length > 0;
    const isHomeDelivery = deliveryProducts.length > 0;

    return (
        <>
            <h3>{t("orderOverview.label.products")}</h3>
            <Container>
                {isClickAndCollect && (
                    <ProductCollectionBlockComponent
                        icon={"la-hand-pointer"}
                        title={t("orderOverview.title.clickAndCollect")}
                        products={collectProducts}
                        deliveryType={DeliveryType.ClickAndCollect}
                        productTitleLink={productTitleLink}
                        DeliveryPromiseComponent={DeliveryPromiseComponent}
                    />
                )}
                {isHomeDelivery && (
                    <ProductCollectionBlockComponent
                        icon={"la-truck"}
                        title={t("orderOverview.title.homeDelivery")}
                        products={deliveryProducts}
                        deliveryType={DeliveryType.HomeDelivery}
                        additionalServiceTooltip={additionalServiceTooltip}
                        productTitleLink={productTitleLink}
                        DeliveryPromiseComponent={DeliveryPromiseComponent}
                    />
                )}
            </Container>
        </>
    );
};

export { ProductCollectionBlock };
